export const LIVE_PAGE_SUBTYPE = 'live';
export const LIVE_PAGES_STORE_ID = 'live-pages-store';
